/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';
import PasswordRepository from 'repositories/auth/PasswordRepository';

const initialState = {
  resetPasswordCreatingStatus: FETCH_STATUSES.idle,
  successMessage: '',
};

const resetPasswordSlice = createSlice({
  name: 'resetPasswordSlice',
  initialState,
  reducers: {
    resetPasswordStart(state) {
      state.successMessage = '';
      state.resetPasswordCreatingStatus = FETCH_STATUSES.pending;
    },
    resetPasswordFinish(state, { payload }) {
      const { message } = payload;
      state.resetPasswordCreatingStatus = FETCH_STATUSES.fulfilled;
      state.successMessage = message;
    },
    resetPasswordFail(state) {
      state.resetPasswordCreatingStatus = FETCH_STATUSES.failed;
    },
  },
});

export const { actions } = resetPasswordSlice;

export default resetPasswordSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const resetPassword = async attrs => {
    dispatch(actions.resetPasswordStart());
    try {
      const { message } = await PasswordRepository.resetPassword(attrs);
      dispatch(actions.resetPasswordFinish({ message }));
    } catch (error) {
      dispatch(actions.resetPasswordFail());
      throw error;
    }
  };

  return {
    resetPassword,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/auth/resetPasswordSlice.js